// components/Header.js
import React from 'react';

const Header = ({ cartCount }) => {
  return (
    <header className="app-header">
      <div className="header-top">
        <span className="time">9:16</span>
        <div className="status-bar">
          <span className="signal">●●● </span>
          <span className="wifi">📶</span>
          <span className="battery">66%</span>
        </div>
      </div>
      
      <div className="header-nav">
        <button className="back-btn">←</button>
        <div className="search-bar">
          <input type="text" placeholder="搜索宝贝" />
        </div>
        <div className="header-actions">
          <button className="share-btn">🔗</button>
          <button className="cart-btn">
            🛒<span className="cart-badge">{cartCount}</span>
          </button>
          <button className="favorite-btn">⭐</button>
          <button className="menu-btn">⋯</button>
        </div>
      </div>
      
      <nav className="tab-nav">
        <button className="tab active">宝贝</button>
        <button className="tab">评价</button>
        <button className="tab">详情</button>
        <button className="tab">推荐</button>
      </nav>
      
      <div className="promo-banner">
        ⚡ 平台礼金即时直降 1 元
      </div>
    </header>
  );
};

export default Header;